import React, { useEffect, useState } from "react";
import Header from "../../sharedScreens/Header";
import HotelListFilterCard from "../../components/composite/hotelListCard/hotelFilter/HotelListFilterCard";
import HotelListMainCard from "../../components/composite/hotelListCard/hotelMainCard/HotelListMainCard";
import HotelHeaderCard from "../../components/composite/hotelListCard/hotellistHeader/HotelHeaderCard";
import HotelSubHeaderCard from "../../components/composite/hotelListCard/hotellistHeader/HotelSubHeaderCard";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useLocation, useNavigate } from "react-router-dom";
import HotelListLoader from "../../components/composite/hotelListCard/HotelListLoader";
import HotelDetailTabCard from "../../components/composite/hoteldetailcard/HotelDetailTabCard";
import { RoomOption } from "../../components/composite/hoteldetailcard/RoomList";
import { HotelServices } from "../../services/hotelSearch/HotelSearchService";
import { Slider } from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import { useGlobalState } from "../../services/context/AuthContext";

interface HotelData {
  HotelName: string;
  price: {
    old: number;
    current: number;
    taxes: number;
  };
  ImageThumbUrl: string;
  address: string;
  rating: string;
  EMTCommonId: string;

  tripAdvisorReviewCount: number;
  AvailableRoom: any[];
  Location: string;
  viewers: number;
  HotelID: string;
  Engine: number;
  MealType: string;
  RateKey: string;
  RoomType: string;
  RoomTypeCode: string;
  currency: string;
  CheckInTime?: string;
  CheckOutTime?: string;
}

const HotelList: React.FC = () => {
  const { userInfo } = useGlobalState();
  const currency = userInfo?.currencyCode || "AED";
  const [filteredHotels, setFilteredHotels] = useState<HotelData[]>([]);
  const [visibleCount, setVisibleCount] = useState<number>(20);
  const [allHotels, setAllHotels] = useState<HotelData[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  const [selectedPriceFilters, setSelectedPriceFilters] = useState<string[]>(
    []
  );
  const [selectedLocationFilters, setSelectedLocationFilters] = useState<
    string[]
  >([]);
  const [locationOptions, setLocationOptions] = useState<
    { id: string; label: string }[]
  >([]);
  const [selectedStarFilters, setSelectedStarFilters] = useState<string[]>([]);
  const [sortBy, setSortBy] = useState<string>("");
  const [totalHotelCount, setTotalHotelCount] = useState<number>(0);
  const [totalViwerCount, setTotalViwerCount] = useState<number>(0);
  const [city, setCity] = useState<string>("");
  const [country, setCountry] = useState<string>("");
  const [expandedHotelId, setExpandedHotelId] = useState<string | null>(null);
  const [priceRange, setPriceRange] = useState<{ min: number; max: number }>({
    min: 0,
    max: 0,
  });
  const [selectedPriceRange, setSelectedPriceRange] = useState<
    [number, number]
  >([0, 0]);

  const location = useLocation();
  const navigate = useNavigate();
  // const payloadFromForm = location.state?.payload;

  const filterOptions = [
    { id: "freeCancellation", label: "Free Cancellation" },
    { id: "freeBreakfast", label: "Free Breakfast" },
    { id: "freeParking", label: "Free Parking" },
  ];

  const starOptions = [
    { id: "5 Star", label: "5 Star" },
    { id: "4 Star", label: "4 Star" },
    { id: "3 Star", label: "3 Star" },
    { id: "2 Star", label: "2 Star" },
    { id: "1 Star", label: "1 Star" },
    { id: "Unrated", label: "Unrated" },
  ];

  const [payloadFromForm, setPayloadFromForm] = useState(() => {
    return (
      location.state?.payload ||
      JSON.parse(sessionStorage.getItem("hotelSearchPayload") || "{}")
    );
  });

  // Save once when location.state updates
  useEffect(() => {
    if (location.state?.payload) {
      sessionStorage.setItem(
        "hotelSearchPayload",
        JSON.stringify(location.state.payload)
      );
      setPayloadFromForm(location.state.payload);
    }
  }, [location.state]);

  const toggleHotelDetails = (id: string) => {
    setExpandedHotelId((prev) => (prev === id ? null : id));
  };
  useEffect(() => {
    if (payloadFromForm?.selectedStars) {
      // Normalize "2", "3", etc. into "2 Star", "3 Star"
      const starFilters = payloadFromForm.selectedStars.map(
        (s: number) => `${s} Star`
      );
      setSelectedStarFilters(starFilters);
    }
  }, [payloadFromForm]);
  useEffect(() => {
    const fetchHotels = async () => {
      if (!payloadFromForm || !payloadFromForm.CityName) return;
      setLoading(true);
      try {
        const hotelList = await HotelServices.getHotelList(payloadFromForm);
        setTotalHotelCount(hotelList?.data?.HotelCount || 0);
        setTotalViwerCount(hotelList?.data?.MostViewedNo || 0);
        setCity(payloadFromForm?.CityName || "");
        setCountry(payloadFromForm?.CountryName || "India");

        const data = hotelList?.data?.hotellist?.map((hotel: any) => {
          const firstRoom = hotel.AvailableRoom?.[0] || {};
          const priceInfo = {
            old: firstRoom.Price || 0,
            current: (firstRoom.Price || 0) - (firstRoom.disc || 0),
            taxes: firstRoom.surchargeTotal || 0,
          };

          return {
            HotelName: hotel.hotelName,
            price: priceInfo,
            ImageThumbUrl: hotel.ImageThumbUrl,
            address: hotel.address,
            rating: hotel.rating,
            EMTCommonId: hotel.EMTCommonID || hotel.EMTCommonId || "",
            tripAdvisorReviewCount: hotel.tripAdvisorReviewCount,
            AvailableRoom: hotel.AvailableRoom || [],
            Location: hotel.Location || hotel.location || "",
            viewers: hotel.MostViewedNo || 0,
            latitude: hotel.latitude || hotel.Latitude || "",
            longtitude: hotel.longtitude || hotel.Longitude || "",
            Engine: firstRoom.Engine,
            HotelID: hotel.hotelID || firstRoom.HotelID,
            MealType: firstRoom.MealType,
            RateKey: firstRoom.rateKey || firstRoom.RateKey || "",
            RoomType: firstRoom.roomType || firstRoom.RoomType || "",
            RoomTypeCode:
              firstRoom.roomTypeCode || firstRoom.RoomTypeCode || "",
            currency: firstRoom.currencyCode || hotel.currencyCode || "INR",
            CheckInTime: hotel.CheckInTime || "12:00 PM",
            CheckOutTime: hotel.CheckOutTime || "11:00 AM",
          };
        });
        if (data.length > 0) {
          const prices = data.map((hotel: any) => hotel.price?.current || 0);
          const minPrice = Math.min(...prices);
          const maxPrice = Math.max(...prices);
          setPriceRange({ min: minPrice, max: maxPrice });
          setSelectedPriceRange([minPrice, maxPrice]);
        }

        // ✅ Sort by price: low to high
        const sortedByPrice = data.sort(
          (a: any, b: any) => (a.price?.current || 0) - (b.price?.current || 0)
        );

        setAllHotels(sortedByPrice);
        setFilteredHotels(sortedByPrice);
        setSortBy("Price: Low to High"); // Optional: sync sort option in UI

        const locations = Array.from(
          new Set(data.map((hotel: any) => hotel?.Location || "Unknown"))
        ).filter(Boolean);

        const locationOptions = locations.map((loc) => ({
          id: loc as string,
          label: loc as string,
        }));

        setLocationOptions(locationOptions);
      } catch (error) {
        console.error("Error loading hotel data:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchHotels();
  }, [payloadFromForm]);

  const handleRoomClick = async (
    hotel: HotelData,
    selectedRoom?: RoomOption
  ) => {
    const room = selectedRoom || hotel.AvailableRoom?.[0];

    if (!room) {
      console.warn("🚫 No room data available to fetch details");
      return;
    }

    const roomsData = Array.isArray(payloadFromForm?.rooms?.Room)
      ? payloadFromForm.rooms.Room
      : [{ NumberOfAdults: 1, Child: { NumberOfChild: 0, childAge: [] } }];

    const payload = {
      CheckInDate: payloadFromForm?.CheckInDate,
      CheckOutDate: payloadFromForm?.CheckOutDate,
      CheckOutTime: hotel.CheckOutTime || "11:00 AM",
      CheckInTime: hotel.CheckInTime || "12:00 PM",
      City: payloadFromForm?.CityName || "",

      EMTCommonID: "EMTHOTEL-4521578",
      Engine: room.Engine,
      HotelID: room.HotelID,
      MealType: room.MealType,
      RateKey: room.rateKey || room.RateKey || "",
      RoomType: room.roomType || room.RoomType || "",
      RoomTypeCode: room.roomTypeCode || room.RoomTypeCode || "",
      Rooms: {
        Count: roomsData.length,
        Room: roomsData,
      },
    };

    try {
      const response = await HotelServices.getRoomDetail(payload);
      const roomData = response?.data?.Rooms?.Room?.[0];
      console.log("roomdata", response?.data);
      if (!roomData) {
        console.warn("⚠️ No room data returned from API");
        return;
      }

      navigate("/hotelroomdetail", {
        state: {
          payload: {
            ...roomData,
            CheckInDate: payload.CheckInDate,
            CheckOutDate: payload.CheckOutDate,
            CheckInTime: payload.CheckInTime,
            CheckOutTime: payload.CheckOutTime,
            Guests: payload.Rooms,
            HotelName: hotel.HotelName,
            HotelAddress: hotel.address,
            HotelImage: hotel.ImageThumbUrl,
            HotelRating: hotel.rating,
            HotelID: room.HotelID,
            Engine: room.Engine,
            MealType: room.MealType,
            RateKey: roomData?.rateKey || room.rateKey,
            RoomType: roomData?.roomType || room.roomType,
            RoomTypeCode: roomData?.roomTypeCode || room.roomTypeCode,
            currencyCode: roomData?.currencyCode || room.currencyCode,
            NP: roomData?.NP || 0,
            NT: roomData?.NT || 0,
            disc: roomData?.disc || 0,
            TotalPrice: roomData?.TotalPrice || roomData?.total || 0,
            CancellationPolicy:
              roomData?.Cancellationpolicy ||
              roomData?.Cancellationpolicy ||
              "",

            BookingPolicy: roomData?.BookingPolicy || "",
            Meal: roomData?.Meal?.mealName || room.Meal || "",
          },
        },
      });
    } catch (error) {
      console.error("❌ Room detail fetch error:", error);
    }
  };

  useEffect(() => {
    if (priceRange.min > 0 && priceRange.max > 0) {
      setSelectedPriceRange([priceRange.min, priceRange.max]);
    }
  }, [priceRange]);

  useEffect(() => {
    let result = [...allHotels];
    if (selectedPriceRange && selectedPriceRange.length === 2) {
      result = result.filter((hotel) => {
        const price = hotel.price?.current || 0;
        return price >= selectedPriceRange[0] && price <= selectedPriceRange[1];
      });
    }

    if (selectedFilters.length > 0) {
      result = result.filter((hotel) => {
        const rooms = hotel?.AvailableRoom || [];
        return rooms.some((room: any) =>
          selectedFilters.every((filter) => {
            const meal = (room.Meal || "").toLowerCase();
            const cancellation = (room.CancellationPolicy || "").toLowerCase();
            switch (filter) {
              case "freeCancellation":
                return cancellation.includes("free cancellation");
              case "freeBreakfast":
                return meal.includes("free breakfast");
              case "freeParking":
                return (
                  meal.includes("free self parking") ||
                  meal.includes("free parking") ||
                  meal.includes("Free self parking")
                );
              default:
                return true;
            }
          })
        );
      });
    }

    if (selectedLocationFilters.length > 0) {
      result = result.filter((hotel) => {
        const loc = hotel?.Location || "";
        return selectedLocationFilters.includes(loc);
      });
    }

    if (selectedStarFilters.length > 0) {
      result = result.filter((hotel) => {
        const hotelRating = parseFloat(hotel.rating);
        return selectedStarFilters.some((selected) => {
          const selectedRating = parseInt(selected);
          return Math.floor(hotelRating) === selectedRating;
        });
      });
    }

    const sortKey = sortBy.toLowerCase();
    if (sortKey === "price: low to high") {
      result.sort((a, b) => (a.price?.current || 0) - (b.price?.current || 0));
    } else if (sortKey === "price: high to low") {
      result.sort((a, b) => (b.price?.current || 0) - (a.price?.current || 0));
    } else if (sortKey === "rating") {
      result.sort((a, b) => parseFloat(b.rating) - parseFloat(a.rating));
    } else if (sortKey === "popularity") {
      result.sort(
        (a, b) =>
          (b.tripAdvisorReviewCount || 0) - (a.tripAdvisorReviewCount || 0)
      );
    }

    setFilteredHotels(result);
    setVisibleCount(20);
  }, [
    selectedPriceRange, // ✅ Make sure this is included
    selectedFilters,
    selectedLocationFilters,
    selectedStarFilters,
    allHotels,
    sortBy,
  ]);

  const visibleHotels = filteredHotels.slice(0, visibleCount);

  return (
    <>
      <div className="grow">
        <div className="wrapper flex grow flex-col">
          <Header />
        </div>
        <HotelHeaderCard
          city={payloadFromForm?.CityName}
          checkIn={payloadFromForm?.CheckInDate}
          checkOut={payloadFromForm?.CheckOutDate}
          roomsData={payloadFromForm?.rooms}
        />
      </div>

      <main className="grow content" role="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-3 margin-bottom-class">
              <div className="card">
                <div className="card-header">
                  <h3 className="card-title">Filter</h3>
                  <FilterAltIcon />
                </div>
                <HotelListFilterCard
                  title="Filter Hotels By "
                  filters={filterOptions}
                  selectedFilters={selectedFilters}
                  onFilterChange={setSelectedFilters}
                />
                <h5 className="filter-header ms-2">Price Range (per night)</h5>
                <div className="card-body">
                  <div className="price-range">
                    <Slider
                      size="small"
                      value={selectedPriceRange}
                      onChange={(_, newValue) =>
                        setSelectedPriceRange(newValue as [number, number])
                      }
                      valueLabelDisplay="auto"
                      min={priceRange.min}
                      max={priceRange.max}
                      step={100}
                      marks
                    />
                  </div>
                  <div className="d-flex justify-content-between mt-2">
                    <span>{currency} {priceRange.min}</span>
                    <span>{currency} {priceRange.max}</span>
                  </div>
                </div>
                <HotelListFilterCard
                  title="Popular Locations"
                  filters={locationOptions}
                  selectedFilters={selectedLocationFilters}
                  onFilterChange={setSelectedLocationFilters}
                />
                <HotelListFilterCard
                  title="Star Rating"
                  filters={starOptions}
                  selectedFilters={selectedStarFilters}
                  onFilterChange={setSelectedStarFilters}
                />{" "}
              </div>
            </div>

            <div className="col-md-9 ">
              <HotelSubHeaderCard
                onSortChange={(value) => setSortBy(value)}
                totalCount={totalHotelCount}
                city={city}
                country={country}
                loading={loading}
              />

              {loading && <HotelListLoader count={5} />}
              {!loading && visibleHotels.length === 0 && (
                <div className="d-flex flex-column align-items-center justify-content-center py-4">
                  <div
                    className="d-flex align-items-center justify-content-center bg-light rounded-circle mb-3"
                    style={{ width: "80px", height: "80px" }}
                  >
                    <img
                      src="media/images/remove-folder.png"
                      alt="remove-folder"
                      style={{ maxWidth: "40px", maxHeight: "40px" }}
                    />
                  </div>
                  <h5 className="text-muted mb-0 fw-bold fs-5">
                    No hotels match your filters.
                  </h5>
                </div>
              )}
              {!loading &&
                visibleHotels.map((hotel, index) => {
                  const isExpanded = expandedHotelId === hotel.EMTCommonId;
                  return (
                    <div key={index}>
                      <HotelListMainCard
                        EMTCommonId={hotel.EMTCommonId}
                        name={hotel.HotelName}
                        location={hotel.address}
                        rating={hotel.rating}
                        price={hotel.price}
                        tripAdvisorReviewCount={hotel.tripAdvisorReviewCount}
                        discount=""
                        mainImage={hotel.ImageThumbUrl}
                        thumbnails={[hotel.ImageThumbUrl]}
                        features={Array.from(
                          new Set(
                            hotel?.AvailableRoom?.flatMap(
                              (room: any) =>
                                room.Meal?.split(",").map((item: string) =>
                                  item.trim()
                                ) ?? []
                            )
                          )
                        )}
                        viewers={hotel.viewers}
                        onDetailsToggle={toggleHotelDetails}
                        onViewRoomClick={() => handleRoomClick(hotel)}
                      />
                      {isExpanded && (
                        <div className="mb-4">
                          <HotelDetailTabCard
                            hotel={hotel}
                            roomDetails={undefined}
                            onBookRoom={(room) => handleRoomClick(hotel, room)} // ✅ pass hotel + selected room
                          />
                        </div>
                      )}
                    </div>
                  );
                })}

              {!loading && visibleCount < filteredHotels.length && (
                <div className="text-center my-4">
                  <button
                    className="btn leran-more-color d-flex align-items-center gap-1 ms-auto"
                    onClick={() => setVisibleCount((prev) => prev + 20)}
                  >
                    Load More <ArrowForwardIcon />
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </main>
    </>
  );
};

export default HotelList;
